import { render, staticRenderFns } from "./LeftFourth.vue?vue&type=template&id=45db2840&scoped=true"
import script from "./LeftFourth.vue?vue&type=script&lang=js"
export * from "./LeftFourth.vue?vue&type=script&lang=js"
import style0 from "./LeftFourth.vue?vue&type=style&index=0&id=45db2840&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45db2840",
  null
  
)

export default component.exports